var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"none-data",class:{ border: _vm.border },style:({ height: `${_vm.height ? _vm.height : 500}px` })},[_c('img',{style:({ height: `${_vm.imgHeight ? _vm.imgHeight : 177}px` }),attrs:{"src":_vm.imgUrl || _vm.zanwushuju,"alt":""}}),_c('p',[_vm._v(_vm._s(_vm.text || '暂无数据'))])])
}
var staticRenderFns = []

export { render, staticRenderFns }